module.exports = __webpack_public_path__ + "static/media/questions-circular.5d2e5e0b.svg";